import { Link } from '@mui/material';
import type { Components } from 'react-markdown';
import { helpPanel, parseHelpLink } from '@/features/help/helpPanelStore';

/** The URL schemes `LazyMarkdown` must keep for help links; its safe defaults drop them. */
export const HELP_LINK_SCHEMES = ['help:'];

/**
 * Markdown elements for text that links help sections (`help:<page id>#<anchor>`) — a release note, an answer of
 * the assistant: such a link opens the help panel at the section. Every other link stays an ordinary link.
 * Render with `keepSchemes={HELP_LINK_SCHEMES}`.
 */
export const helpLinkComponents: Components = {
  a: ({ href, children }) => {
    const target = parseHelpLink(href);
    if (!target) return <a href={href}>{children}</a>;
    return (
      <Link component="button" onClick={() => helpPanel.openAt(target)} sx={{ verticalAlign: 'baseline', font: 'inherit' }}>
        {children}
      </Link>
    );
  },
};
